export const OEVersion = {
    amboss:                 'AMBOSS',
    anatomy:                'ANATOMY',
    bayer:                  'BAYER',
    bbraun:                 'BBRAUN',
    cambridgeCell:          'CAMBRIDGECELL',
    cell:                   'CELL',
    demo:                   'DEMO',
    ear:                    'EAR',
    effigos:                'EFFIGOS',
    equineHoof:             'EQUINEHOOF',
    eyeOCT:                 'EYEOCT',
    implantcast:            'IMPLANTCAST',
    ionto:                  'IONTO',
    kind:                   'KIND',
    knowOn:                 'KNOWON',
    licensingStart:         'licensingStart',
    ortho:                  'ORTHO',
    santen:                 'SANTEN',
    school:                 'SCHOOL',
    science:                'SCIENCE',
    skin:                   'SKIN',
    sport:                  'SPORT',
    surgery:                'SURGERY',
    thieme:                 'THIEME',
    toxnetz:                'TOXNETZ',
    visionResearch:         'VISIONRESEARCH',
    xRay:                   'XRAY',
    xRayMin:                'XRAYMIN',
    xRayIcarus:             'XRAYICARUS',
    zeissOpti:              'ZEISSOPTI'
};